import AddSupplier from './EditSupplier';

export default AddSupplier;